<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Oorl5d/tc-custom/9781429939874.jpg?1737776861609" alt="This image is the cover for the book The Killer's Wife"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Killer's Wife
      </h1>
      <p class="bookDescription body article font2">
        <p>Six years after her courageous testimony helped put her husband on death row for a string of gruesome murders, Leigh Wren has almost succeeded in putting her past to rest.  She has moved from the West Coast to North Carolina with her young son, adopting a new name and a new life.  But the world that she has created for herself is shattered when the father of one of her ex-husband's victims begins stalking her, then confronts her late one night.  In the days that follow, he exposes Leigh, in newspapers and on television, to a startled North Carolina community.  And just as her marriage to Randall Mosley, a man who became known to the world as a deviant serial killer, is brought back to light, a more deadly game of cat and mouse ensues.<br/><br/> A new killer has emerged, one whose methods are frighteningly similar to those used by Mosley, who is awaiting execution thousands of miles away.  Leigh and her son appear to be in the assailant's scope, and it becomes clear that he is more than a copycat killer—his targets are all tied to Leigh's former life.  With the clock ticking down and the victims of a new killer mounting, Leigh is forced to probe the darkest corridors of her past to protect her life and her son's.  She must also confront her own feelings of responsibility: Leigh has always professed her ignorance, but how complicit <i>was </i>she in her husband's horrific murder spree, as it was taking place?<br/><br/> From a major new voice in suspense, <i>The Killer's Wife</i> is a story driven by psychological insight and harrowing revelations, asking how well you can ever <i>really</i> know the person sleeping beside you.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bill Floyd
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ad4891a